import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Form } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ProposalReviseView from '../../components/forms/proposalReviseForm/ProposalReviseView'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function ProposalMoreRequest(props) {
  const { onSuccess = () => {},schema, schemaButton } = props
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const onSubmit = (data) => {
    console.log('onSubmit', data)
  }

  return (
    <>
      <Form fluid>
        <Panel shaded header="" bordered collapsible defaultExpanded>
          <ProposalReviseView
            schema={formSchema.revises}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
          {/* <hr />
          <SaveButton onClick={handleSubmit(onSubmit)}>ส่งกลับผู้ขอรับทุน</SaveButton> */}
          {schemaButton?.checkButton && (
            <ApproverList
              approveType={6}
              projectversionId={projectId}
              style={{ marginLeft: 10 }}
              buttontext={schemaButton?.checkButton}
              fetchButton={(disabled) =>
                schemaButton?.fetchButton && (
                  <FetchNewApprover
                    approveType={6}
                    projectversionId={projectId}
                    style={{ marginRight: 10, marginBottom: 10 }}
                    buttontext={schemaButton?.fetchButton}
                    onSuccess={onSuccess}
                    disabled={disabled}
                  />
                )
              }
            />
          )}

          {schemaButton?.cancelButton && (
            <CancelApprovalList
              approveType={6}
              projectversionId={projectId}
              style={{ marginRight: 10, marginLeft: 10 }}
              buttontext={schemaButton?.cancelButton}
              onSuccess={onSuccess}
            />
          )}

        </Panel>
        <br />
      </Form>
    </>
  )
}
